import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderDateGroupDTO  {
    _originalTypeClassName = "ekylikeio.BO.OrderDateGroupDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderDateGroupDTO.translate = translateService;
}
this.Items = [];
this.Date = null;
this.TotalPrice = null;
this.OrderDateGroupDTOKey = null;
this._key = this.OrderDateGroupDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
TotalPrice:any;
Items:any;
private _OrderDateGroupDTOKey:any;
get OrderDateGroupDTOKey(): any {
    return this._OrderDateGroupDTOKey;
  }
set OrderDateGroupDTOKey(value: any) {
    this._OrderDateGroupDTOKey = value;
    this._key = value;
  }
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.OrderDateGroupDTO.removeItems($this, $this.Items[0]);
                }

                Domain.OrderDateGroupDTO.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderDateGroupDTO.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderDateGroupDTO.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrderDateGroupDTOKey == null || $this.OrderDateGroupDTOKey == 0;
            }


}